export const toggleValueInArray = (
  options: string[],
  target: string
): string[] => {
  let checkboxValue: string[];
  if (options.includes(target)) {
    checkboxValue = options.filter((option) => option !== target);
  } else {
    checkboxValue = [...options, target];
  }
  return checkboxValue;
};
